import { createAction, emptyProps, props } from '@ngrx/store';
import { IBottle } from 'app/models/bottle';

export const clearAllItems = createAction('[DalHelper] Clear All Bottles');
export const loadItems = createAction('[App Bottle List Page] Load Bottles');
export const loadItemsSuccess = createAction('[Bottle API] Load Bottles Success', props<{ items: IBottle[] }>());
export const loadItemsFailure = createAction('[Bottle API] Load Bottles Failure', props<{ error: any }>());

export const setItemFromListPage = createAction('[Bottle List Page] Set Selected Item', props<{ id: string }>());
export const setItem = createAction('[Bottle Page] Set Selected Item', props<{ id: string }>());
export const setEan = createAction('[Bottle Page] Set Selected Bottle EAN', props<{ ean: string }>());
export const setError = createAction('[Bottle Page] Set Error', props<{ error: string }>());

export const addItem = createAction('[Bottle Detail Page] Add Bottle', props<{ id: string, item: IBottle }>());
export const addItemSuccess = createAction('[Bottle API] Add Bottle Success', props<{ item: IBottle }>());
export const addItemFailure = createAction('[Bottle API] Add Bottle Failure', props<{ error: any }>());

export const deleteItem = createAction('[Bottle Detail Page] Delete Bottle', props<{ id: string }>());
export const deleteItemSuccess = createAction('[Bottle API] Delete Bottle Success');
export const deleteItemFailure = createAction('[Bottle API] Delete Bottle Failure', props<{ error: any }>());

export const softUpdate = createAction('[Bottle API] Soft Update Bottle', props<{ id: string, data: any, uid: string }>());
export const softUpdateSuccess = createAction('[Bottle API] Soft Update Bottle Success', props<{ id: string, data: any }>());
export const softUpdateFailure = createAction('[Bottle API] Soft Update Bottle Failure', props<{ error: any }>());

export const updateItem = createAction('[Bottle Detail Page] Update Bottle', props<{ item: IBottle }>());
export const updateItemSuccess = createAction('[Bottle API] Update Bottle Success', props<{ item: IBottle }>());
export const updateItemFailure = createAction('[Bottle API] Update Bottle Failure', props<{ error: any }>());
